import { motion } from 'framer-motion';
import { memo, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../assets/logo-text.png';
import { BellIcon, UserIcon } from './icons';

export const Header = memo(function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(true);
  const lastScrollY = useRef(0);

  const isActive = (path: string) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY <= 8) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY.current) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }

      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: 0, opacity: 1 }}
      animate={{
        y: isVisible ? 0 : -80,
        opacity: isVisible ? 1 : 0.9,
      }}
      transition={{ duration: 0.22, ease: 'easeOut' }}
      className="fixed top-0 left-0 right-0 bg-[#1a1a1a]/30 z-10"
    >
      <header className="sticky top-0 z-10 flex items-center justify-between gap-3 px-4 py-3 backdrop-blur-md bg-bg-primary/80">
        <div className="flex items-center gap-2">
          <div className="w-32 h-12 rounded-lg flex items-center justify-center">
            <img src={logo} alt="MMB logo" className="w-32" />
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => navigate('/notifications')}
            className={`p-2 rounded-lg transition-colors ${
              isActive('/notifications')
                ? 'bg-accent-bg text-accent'
                : 'hover:bg-[#262626] text-[#a0a0a0]'
            }`}
          >
            <BellIcon size={22} />
          </button>
          <button
            type="button"
            onClick={() => navigate('/profile')}
            className={`p-2 rounded-lg transition-colors ${
              isActive('/profile')
                ? 'bg-accent-bg text-accent'
                : 'hover:bg-[#262626] text-[#a0a0a0]'
            }`}
          >
            <UserIcon size={22} />
          </button>
        </div>
      </header>
    </motion.header>
  );
});
